<template>
  <b-modal
    ref="modalSubmitProductKompack"
    size="md"
    body-class="p-2"
    static
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <img
      src="https://storage.googleapis.com/komerce/assets/icons/success.svg"
      alt="Pengajuan Produk Berhasil"
      class="h-[102px] w-[110px] mx-auto mb-[24px]"
    >
    <h3 class="text-black font-semibold text-[20px] text-center mb-[8px]">
      Gudang siap digunakan!
    </h3>
    <p class="text-center text-black">
      Yuk! Ajukan produkmu terlebih dahulu agar mitra dapat meninjau sebelum inbound.
    </p>
    <b-button
      variant="primary"
      class="!w-full"
      @click="handleSubmitProduct"
    >
      Ajukan Produk
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalSubmitProduct',
  data() {
    return {
      warehouseId: null,
      mitraId: null,
    }
  },
  methods: {
    show({
      warehouseId,
      mitraId,
    }) {
      this.warehouseId = warehouseId
      this.mitraId = mitraId
      this.$refs.modalSubmitProductKompack.show()
    },
    hide() {
      this.$refs.modalSubmitProductKompack.hide()
    },
    handleSubmitProduct() {
      this.$emit('submit-product', {
        warehouseId: this.warehouseId,
        mitraId: this.mitraId,
      })
    },
  },
}
</script>

<style scoped>

</style>
